import React,{useState} from 'react'
import Canvas from "../canvas/Canvas"

import thumb12 from '../images/thumb_12.jpg';
import thumb13 from '../images/thumb_13.jpg';

import img12 from '../images/12.png';
import img13 from '../images/13.png';

import { Modal } from 'react-bootstrap';
import "./modal.css"

export default function Pathology(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img12);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    return(
        <>
           <div className="card card-custom gutter-b">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="card-lable">
                            Pathology Eyelids
                        </h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb12}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Blepharitis</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Pathology Eyelids - Blepharitis",img12)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb13}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Stye/Hordeolum</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Pathology Eyelids - Stye/Hordeolum",img13)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 



                    </div>
                </div>
            </div>   
            <Modal
                show={show}
                size="lg"
                onHide={()=>setShow(false)}
                dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                      
                        <Modal.Title>
                            Eye Draw - {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>     
                      {/*   <Image src={img1} fluid />*/}
                      <div style={{height:"70vh",width:"60vw"}}>
                      <Canvas image={showImage} />
                      </div>
                     
                    </Modal.Body>
                </Modal>          
        </>
    )
}